module.exports = __webpack_public_path__ + "static/media/add short leave.65cfe217.svg";